export const SET_HRESH1X_INDEX_DISP = 'SET_HRESH1X_INDEX_DISP'
export const GET_HRESH1X_INDEX_DISP = 'GET_HRESH1X_INDEX_DISP'
export const SET_HRESH1X_DETAIL_DISP = 'SET_HRESH1X_DETAIL_DISP'
export const GET_HRESH1X_DETAIL_DISP = 'GET_HRESH1X_DETAIL_DISP'
export const SET_HRESH1X_COLUMNS = 'SET_HRESH1X_COLUMNS'
export const GET_HRESH1X_COLUMNS = 'GET_HRESH1X_COLUMNS'
export const GET_HRESH1X_MAX_ROWSPAN = 'GET_HRESH1X_MAX_ROWSPAN'
export const SET_HRESH1X_LABELS = 'SET_HRESH1X_LABELS'
export const GET_HRESH1X_LABELS = 'GET_HRESH1X_LABELS'
export const RECEIVED_HRESH1X_COLUMNS_LABELS = 'RECEIVED_HRESH1X_COLUMNS_LABELS'
export const SET_HRESH1X_INDEX = 'SET_HRESH1X_INDEX'
export const GET_HRESH1X_INDEX = 'GET_HRESH1X_INDEX'
export const SET_HRESH1X_INDEX_SELECTED = 'SET_HRESH1X_INDEX_SELECTED'
export const GET_HRESH1X_INDEX_SELECTED = 'GET_HRESH1X_INDEX_SELECTED'
export const RECEIVED_HRESH1X_INDEX = 'RECEIVED_HRESH1X_INDEX'
export const SET_HRESH1X_DETAIL = 'SET_HRESH1X_DETAIL'
export const GET_HRESH1X_DETAIL = 'GET_HRESH1X_DETAIL'
export const RECEIVED_HRESH1X_DETAIL = 'RECEIVED_HRESH1X_DETAIL'
export const TOGGLE_HRESH1X_PAGE = 'TOGGLE_HRESH1X_PAGE'



// WEBPACK FOOTER //
// ./src/store/modules/hresh1x/mutation-types.js